<template>
  <component :is="itemComponent.is" v-bind="itemComponent.props" v-on="itemComponent.listeners" />
</template>

<script>
import SubscriptionOrderItem from './SubscriptionOrderItem.vue'
import RegularOrderItem from './RegularOrderItem.vue'

export { SIZE_MODIFIERS } from './OrderItemBlock.vue'

export default {
  name: 'OrderItem',

  props: {
    id: { type: Number, required: true },
    orderIndex: { type: Number, required: true },
    item: { type: Object, required: true },
    sizeModifier: { type: String },
    isStockIgnored: { type: Boolean },
    isMerging: { type: Boolean },
    isTransitioning: { type: Boolean },
    isReadOnly: { type: Boolean },
    isShowingFullGiftCardMsg: { type: Boolean },
    isSubscriptionItem: { type: Boolean, default: false },
    onRemoveItemFromCart: { type: Function },
  },

  data() {
    return {
      isHidden: false,
      isRemoved: false,
    }
  },

  computed: {
    itemComponent() {
      const listeners = {
        ...this.$listeners,
        'remove-item': this.removeItem,
      }
      if (this.isSubscriptionItem) {
        return {
          is: SubscriptionOrderItem,
          props: {
            id: this.id,
            name: this.item.name,
            imageUrl: this.item.imageUrl,
            descriptionLines: this.item.details,
            quantity: this.item.quantity,
            price: this.item.price,
            isMerging: this.isMerging,
            isTransitioning: this.isTransitioning,
            isHidden: this.isHidden,
            isRemoved: this.isRemoved,
            isReadOnly: this.isReadOnly,
            sizeModifier: this.sizeModifier,
          },
          listeners,
        }
      }
      return {
        is: RegularOrderItem,
        props: {
          id: this.id,
          variantId: Number(this.item.variantId),
          imageUrl: this.item.imageUrl,
          productPath: this.item.productPath,
          productType: this.item.productType,
          sku: this.item.sku,
          variantSku: this.item.variantSku,
          groupName: this.item.groupName,
          color: this.item.color,
          size: this.item.size,
          price: this.item.price,
          quantity: this.item.quantity,
          viewmode: this.item.viewmode,
          lineItemId: this.item.lineItemId,
          stock: this.item.stock,
          isStockIgnored: this.isStockIgnored,
          isMerging: this.isMerging,
          isTransitioning: this.isTransitioning,
          isHidden: this.isHidden,
          isRemoved: this.isRemoved,
          isReadOnly: this.isReadOnly,
          sizeModifier: this.sizeModifier,
          flashContext: this.item.flashContext,
          giftCardMessage: this.item.giftCardMessage,
          isBackorderable: this.item.isBackorderable,
          isShowingFullGiftCardMsg: this.isShowingFullGiftCardMsg,
        },
        listeners,
      }
    },
  },

  methods: {
    removeItem(element) {
      element.style.height = `${element.offsetHeight}px`
      // First animate disappearance of item
      this.$nextTick(() => (this.isHidden = true))

      setTimeout(() => {
        // Needed for animation purposes
        this.isHidden = false
        this.isRemoved = true
        this.$nextTick(() => (this.isRemoved = false))
        this.onRemoveItemFromCart({
          orderIndex: this.orderIndex,
          isSubscriptionItem: this.isSubscriptionItem,
        })
      }, On.TransitionTimes.slow)
    },
  },
}
</script>
